import React, {useState} from "react";
import Button from "../../../../../components/button/button.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import {Modal} from "../../../../../components/modal/modal.jsx";
import {FaExternalLinkAlt} from "react-icons/fa";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import projectUtils from "../../../../../utils/project-utils.js";
import DispatchService from "../../../../../services/dispatch/dispatch-service.js";

const DispatchBoGenerator = ({dispatchId, boName, occurrenceNumber, occurrenceNumberCode, activity, natureLabel, garrisonLabel, addressLabel, onGenerated, onLoadingChange}) => {
    const navigate = navigateHook();
    const [isGenerating, setIsGenerating] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);

    if (!(occurrenceNumber || !activity)) return null;

    const openBo = () => {
        if (!occurrenceNumber) return;
        const code = occurrenceNumber.replace("/", "-");
        navigate(`/bo/redirect/${code}`, true);
    };

    const generateBo = () => {
        setShowConfirmation(false);
        onLoadingChange?.(true);
        DispatchService.generateNumberBo(dispatchId)
            .then((data) => {
                if (data === null || data === "") {
                    projectUtils.swalMessage("error", "Erro", `A natureza não permite número de ${boName}`);
                    return;
                }
                onGenerated(data.id, data.code);
            })
            .catch((error) => {
                console.error(error);
                let message = `Não foi possível gerar um número de ${boName}`;
                if (error.response?.status !== 500) {
                    message = error.response?.data?.errorMessages ?? error.response?.data?.message ?? message;
                }
                projectUtils.swalErrorMessage("", message, "Ok");
            })
            .finally(() => {
                setIsGenerating(false);
            });
    };

    return (
        <>
            <div className="col-span-2 flex items-end gap-2">
                {occurrenceNumber ? (
                    <>
                        <InputForm
                            classNameWrapper="flex-1"
                            id="occurrenceNumberValue"
                            label={`Nº ${boName}`}
                            value={occurrenceNumber}
                            disabled
                        />
                        <Button type="button" target="primary-outline" title={`Abrir ${boName}`} onClick={openBo}>
                            <FaExternalLinkAlt/>
                        </Button>
                    </>
                ) : (
                    <Button type="button" target="warning" className="w-full" onClick={() => setShowConfirmation(true)} loading={isGenerating} loadingText="Gerando...">
                        Gerar Nº {boName}
                    </Button>
                )}
            </div>

            {occurrenceNumber && (
                <div className="col-span-2">
                    <InputForm
                        id="occurrenceNumberCodeValue"
                        label={`Localizador do ${boName}`}
                        value={occurrenceNumberCode ?? ""}
                        disabled
                    />
                </div>
            )}

            <Modal
                open={showConfirmation}
                setOpen={setShowConfirmation}
                title={`Gerar número de ${boName}?`}
                className="w-11/12 sm:w-6/12 lg:w-4/12"
            >
                <Modal.Body className="space-y-3 text-sm text-[#676a6c]">
                    <strong>Dados do despacho:</strong>
                    <p>{natureLabel}</p>
                    <p>{addressLabel}</p>
                    <p>{garrisonLabel}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={generateBo}>Gerar</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DispatchBoGenerator;